"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
document.addEventListener('alpine:init', function () {
    Alpine.data('resellerLookup', function (locations) {
        var map;
        var infoWindow;
        var LatLngBounds;
        var DISTANCE = 100; // km. Anything further will be filtered out.
        var RECOMMENDED_THRESHOLD = 10; // km. Any recommended retailer that is further than this will not be sorted to the top.
        // Original source: https://www.npmjs.com/package/@anatoliy-stepanchenko/geodistance-calculator
        // Modified slightly and added TS typings.
        function calculateDistance(origin, destination) {
            var lat1 = origin.lat, lon1 = origin.lng;
            var lat2 = destination.lat, lon2 = destination.lng;
            var earthRadius = 6371; // Earth's radius in kilometers.
            var lat1Rad = (lat1 * Math.PI) / 180;
            var lon1Rad = (lon1 * Math.PI) / 180;
            var lat2Rad = (lat2 * Math.PI) / 180;
            var lon2Rad = (lon2 * Math.PI) / 180;
            var dLat = lat2Rad - lat1Rad;
            var dLon = lon2Rad - lon1Rad;
            // Calculation using the haversine formula (the formula is divided into two parts).
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return earthRadius * c;
        }
        // Retrieves the state from the place object returned by Google Places API.
        function getStateFromPlace(place, nameType) {
            if (!place || !place.address_components)
                return '';
            for (var _i = 0, _a = place.address_components; _i < _a.length; _i++) {
                var component = _a[_i];
                if (component.types.includes('administrative_area_level_1')) {
                    return nameType === 'long' ? component.long_name : component.short_name;
                }
            }
            return '';
        }
        return {
            locations: [],
            filteredLocations: [],
            selectedLocation: null,
            mapView: true,
            searched: false,
            hideDistance: false,
            inputs: {
                place: '',
                placeLat: null,
                placeLng: null,
                state: '',
                stateShort: '',
                searchType: '',
            },
            errors: {
                place: '',
            },
            init: function () {
                // Resets the state of the filtered locations.
                this.reset();
                this.initSuburbAutocomplete();
                this.initGoogleMaps();
            },
            initSuburbAutocomplete: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var Autocomplete, autocomplete;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.$store.app.loadGooglePlaces()];
                            case 1:
                                Autocomplete = (_a.sent()).Autocomplete;
                                autocomplete = new Autocomplete(this.$refs.suburbField, {
                                    types: ['geocode'],
                                    componentRestrictions: { country: 'au' },
                                });
                                autocomplete.addListener('place_changed', function () {
                                    // Reset the 'place' fields.
                                    _this.inputs.place = '';
                                    _this.inputs.placeLat = null;
                                    _this.inputs.placeLng = null;
                                    _this.inputs.state = '';
                                    _this.inputs.stateShort = '';
                                    _this.inputs.searchType = '';
                                    try {
                                        var place = autocomplete.getPlace();
                                        _this.inputs.place = place.formatted_address || '';
                                        _this.inputs.placeLat = place.geometry.location.lat();
                                        _this.inputs.placeLng = place.geometry.location.lng();
                                        _this.inputs.state = getStateFromPlace(place, 'long');
                                        _this.inputs.stateShort = getStateFromPlace(place, 'short');
                                        _this.hideDistance = false;
                                        // Determine what the user has searched for based on the place types.
                                        if (place.types.includes('country')) {
                                            _this.inputs.searchType = 'country';
                                        }
                                        else if (place.types.includes('administrative_area_level_1')) {
                                            // Hide the distance for a state search.
                                            _this.hideDistance = true;
                                            _this.inputs.searchType = 'state';
                                        }
                                        else if (place.types.includes('locality') || place.types.includes('sublocality')) {
                                            _this.inputs.searchType = 'suburb';
                                        }
                                        else if (place.types.includes('postal_code')) {
                                            _this.inputs.searchType = 'postcode';
                                        }
                                        else if (place.types.includes('premise')) {
                                            _this.inputs.searchType = 'address';
                                        }
                                        // Reset the error upon selection of result.
                                        _this.errors.place = '';
                                        // If anyone searches for Australia, reset the map and locations.
                                        if (_this.inputs.searchType === 'country') {
                                            _this.searched = false;
                                            _this.zoomReset();
                                            _this.reset();
                                        }
                                        else {
                                            _this.submit();
                                        }
                                    }
                                    catch (e) { }
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
            getAustraliaCenter: function () {
                return {
                    lat: -25.2744,
                    lng: 133.7751,
                };
            },
            initGoogleMaps: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var GoogleMaps;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.$store.app.loadGoogleMaps()];
                            case 1:
                                GoogleMaps = _a.sent();
                                // Store the variable so use it later.
                                LatLngBounds = GoogleMaps.LatLngBounds;
                                infoWindow = new GoogleMaps.InfoWindow({ minWidth: 300 });
                                map = new GoogleMaps.Map(this.$refs.map, {
                                    zoom: 5,
                                    center: this.getAustraliaCenter(),
                                    mapId: GoogleMaps.MAP_ID,
                                });
                                // Add all the markers.
                                locations.forEach(function (location) {
                                    if (!location.lat || !location.lng)
                                        return;
                                    var content = document.createElement('div');
                                    content.innerHTML = location.recommended ? GoogleMaps.pinSvg : GoogleMaps.dotSvg;
                                    var marker = new GoogleMaps.AdvancedMarkerElement({
                                        map: map,
                                        position: { lat: location.lat, lng: location.lng },
                                        content: content,
                                    });
                                    location.marker = marker;
                                    marker.addListener('click', function () {
                                        _this.selectedLocation = location;
                                        _this.openInfoWindow();
                                    });
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
            openInfoWindow: function () {
                var _this = this;
                this.$nextTick(function () {
                    var clone = _this.$refs.selectedLocationInfo.cloneNode(true);
                    // Remove unnecessary attributes/classes from the cloned template.
                    clone.removeAttribute('inert');
                    clone.removeAttribute('aria-hidden');
                    clone.removeAttribute('x-ref');
                    clone.classList.remove('hidden');
                    // Find 'trackable' links within the info window and track it when clicked.
                    var trackables = Array.from(clone.querySelectorAll('[data-trackable-link]'));
                    trackables.length &&
                        trackables.forEach(function (trackable) {
                            trackable.addEventListener('click', function () {
                                _this.trackLink(trackable, _this.selectedLocation);
                            });
                        });
                    infoWindow.setContent(clone);
                    infoWindow.open(map, _this.selectedLocation.marker);
                });
            },
            submit: function () {
                var _this = this;
                if (!this.validate())
                    return;
                var filteredLocations = [];
                var origin = { lat: this.inputs.placeLat, lng: this.inputs.placeLng };
                // Calculate distance for each location.
                this.locations.forEach(function (location) {
                    var destination = { lat: location.lat, lng: location.lng };
                    location.distance = calculateDistance(origin, destination);
                });
                if (this.inputs.searchType === 'state') {
                    filteredLocations = this.locations.filter(function (location) {
                        return location.state.toLowerCase() === _this.inputs.stateShort.toLowerCase();
                    });
                }
                else {
                    filteredLocations = this.locations.filter(function (location) {
                        return location.distance <= DISTANCE;
                    });
                }
                // Sort by closest distance.
                filteredLocations.sort(function (a, b) { return (a.distance < b.distance ? -1 : 1); });
                // Split locations by recommended distance threshold.
                var withinRecommendedThreshold = filteredLocations.filter(function (location) { return location.distance <= RECOMMENDED_THRESHOLD; });
                var outsideRecommendedThreshold = filteredLocations.filter(function (location) { return location.distance > RECOMMENDED_THRESHOLD; });
                // Sort Recommended Retailers that are within the threshold to the top.
                withinRecommendedThreshold.sort(function (a, b) {
                    if (a.recommended && !b.recommended)
                        return -1;
                    if (!a.recommended && b.recommended)
                        return 1;
                    return 0;
                });
                this.filteredLocations = [];
                this.$nextTick(function () {
                    _this.filteredLocations = __spreadArray(__spreadArray([], withinRecommendedThreshold, true), outsideRecommendedThreshold, true);
                    // No results, zoom out.
                    if (!_this.filteredLocations.length) {
                        _this.zoomReset();
                    }
                    else {
                        _this.zoomToMarkers();
                    }
                    _this.trackSubmit();
                    // Set to true so we can hide the initial message.
                    _this.searched = true;
                });
            },
            validate: function () {
                var valid = true;
                // Reset errors.
                this.errors.place = '';
                if (!this.inputs.placeLat || !this.inputs.placeLng) {
                    valid = false;
                    this.errors.place = 'Please select your suburb or postcode from the dropdown';
                }
                return valid;
            },
            toggleMapView: function () {
                this.mapView = !this.mapView;
            },
            setCenter: function (point) {
                map.setCenter(point);
            },
            zoomIn: function () {
                map.setZoom(12);
            },
            zoomOut: function () {
                map.setZoom(5);
            },
            zoomReset: function () {
                this.setCenter(this.getAustraliaCenter());
                this.zoomOut();
            },
            zoomToLocation: function (location) {
                this.selectedLocation = location;
                this.setCenter({
                    lat: location.lat,
                    lng: location.lng,
                });
                this.zoomIn();
                this.openInfoWindow();
                this.trackZoom(location);
            },
            zoomToMarkers: function () {
                if (typeof LatLngBounds === 'undefined')
                    return;
                var bounds = new LatLngBounds();
                this.filteredLocations.forEach(function (location) {
                    bounds.extend({
                        lat: location.lat,
                        lng: location.lng,
                    });
                });
                map.fitBounds(bounds);
            },
            reset: function () {
                this.locations = locations;
                this.filteredLocations = [];
                this.$refs.suburbField.value = '';
                // Preselect the first location - nothing is visible with this, but helps prepare the info window.
                this.selectedLocation = this.locations[0];
            },
            distanceText: function (distance) {
                if (distance === 0)
                    return '0 km';
                if (!distance || !this.inputs.place)
                    return '';
                return "".concat(distance.toFixed(2), " km");
            },
            restoreSingleQuotes: function (value) {
                return value.replace('|', "'");
            },
            trackSubmit: function () {
                this.$store.app.track({
                    event: 'form_submit',
                    type: 'submit',
                    trigger: 'submit',
                    form_name: 'reseller-lookup',
                    module: 'reseller-lookup',
                    data: {
                        address: this.inputs.place,
                        state: this.inputs.state,
                        resultsCount: this.filteredLocations.length,
                        lastProduct: this.$store.app.lastProducts[0] || null,
                        lastProducts: this.$store.app.lastProducts || [],
                        lastCollection: this.$store.app.lastCollection,
                    },
                });
            },
            trackLink: function ($el, location) {
                this.$store.app.track({
                    event: 'click_reseller-lookup',
                    type: 'click',
                    module: 'reseller-lookup',
                    data: {
                        title: $el.textContent.trim(),
                        url: $el.href,
                        target: $el.target || '',
                        reseller: (location === null || location === void 0 ? void 0 : location.title) || '',
                        brand: (location === null || location === void 0 ? void 0 : location.brand) || '',
                        lastProduct: this.$store.app.lastProducts[0] || null,
                        lastProducts: this.$store.app.lastProducts || [],
                        lastCollection: this.$store.app.lastCollection,
                    },
                });
            },
            trackZoom: function (location) {
                this.$store.app.track({
                    event: 'click_reseller-zoom',
                    type: 'click',
                    module: 'reseller-lookup',
                    data: {
                        title: location.title || '',
                        reseller: (location === null || location === void 0 ? void 0 : location.title) || '',
                        brand: (location === null || location === void 0 ? void 0 : location.brand) || '',
                        lastProduct: this.$store.app.lastProducts[0] || null,
                        lastProducts: this.$store.app.lastProducts || [],
                        lastCollection: this.$store.app.lastCollection,
                    },
                });
            },
        };
    });
});
